import React from "react";
import { Check } from "lucide-react";
import { FINAL_CALL, ASSETS } from "../../mock";
import RegistrationForm from "../RegistrationForm";

const FinalCall = () => {
  return (
    <section className="relative py-28 border-t border-[#131c31] overflow-hidden" data-testid="final-call-section">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.12]"
        style={{ backgroundImage: `url(${ASSETS.blueprint})` }}
      />
      <div className="absolute inset-0 blueprint-grid opacity-20" />
      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{FINAL_CALL.label}</p>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight mb-10 reveal" data-testid="final-headline">
            Your Next Move Starts With a <span className="text-[#6b9be8]">Clearer Map.</span>
          </h2>
          <ul className="space-y-4 reveal">
            {FINAL_CALL.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-[#c3cde2] text-sm sm:text-base">
                <Check size={16} className="text-[#6b9be8] mt-1 shrink-0" /> {b}
              </li>
            ))}
          </ul>
        </div>
        <div className="border border-[#22304e] bg-[#0c1324]/95 p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.55)] reveal" data-testid="final-form-card">
          <RegistrationForm idPrefix="final" />
        </div>
      </div>
    </section>
  );
};

export default FinalCall;
